export function addProfilePrefix(questions = []) {
  return questions.map((question) => ({
    ...question,
    name: isProfileField(question) ? `profile.${question.name}` : question.name,
  }));
}

function isProfileField(question) {
  return question.type === 'TEXT' || question.type === 'SELECT';
}
